import React, { useEffect, useState } from "react";
import DocumentModal from "../../../components/documentModal";
import ApiService from "../../../Services/user/service";

const Kycdocument = () => {
  const [showModal, setShowModal] = useState(false);
  const [kycStatus, setKycStatus] = useState(0);
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 USER DETAIL (kyc yahan se)
  const getUserData = async () => {
    try {
      const userid = localStorage.getItem("user_id");
      const res = await ApiService.getUserDetail(userid);

      if (res?.data?.data?.length > 0) {
        setKycStatus(res.data.data[0].kyc);
      }
    } catch (error) {
      console.log("User detail error", error);
    }
  };

  // 🔹 DOCUMENT LIST (title + date yahan se)
  const getUserDocumentList = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const res = await ApiService.getUserDocuments(user_id);

      if (res?.data?.data) {
        setDocumentList(res.data.data);
      } else {
        setDocumentList([]);
      }
    } catch (error) {
      console.log("Document list error", error);
      setDocumentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserData();
    getUserDocumentList();
  }, []);

  const timeAgo = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);

  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "min", seconds: 60 },
  ];

  for (let i of intervals) {
    const count = Math.floor(seconds / i.seconds);
    if (count >= 1) {
      return `${count} ${i.label}${count > 1 ? "s" : ""} ago`;
    }
  }
  return "Just now";
};

  return (
    <div className="container-fluid">
      <div className="card shadow-sm">

        {/* HEADER */}
        <div className="card-header">
          <h5 className="card-title mb-0">KYC Document</h5>
        </div>

        {/* BODY */}
    <div className="card-body py-4 ">

  {loading ? (
    <p className="text-center">Loading...</p>
  ) : documentList.length === 0 ? (
    <div className="text-center py-5">
      <p className="text-muted fs-5 mb-4">No KYC document found</p>
      <button
        className="btn btn-primary px-4"
        onClick={() => setShowModal(true)}
      >
        Submit KYC
      </button>
    </div>
  ) : (
    <div className="row">

      {documentList.map((doc, index) => (
        <div className="col-12 mb-3" key={index}>
          <div className="card shadow-sm">

            <div className="card-body d-flex justify-content-between align-items-center">

              {/* LEFT SIDE */}
              <div>
                <h6 className="mb-1 fw-semibold">{doc.title}</h6>
                <small className="text-muted">
                  Uploaded {timeAgo(doc.createdAt)}
                </small>
                 <div>
                {kycStatus === 0 ? (
                  <span className="badge  text-warning ">
                   - Pending
                  </span>
                ) : (
                  <span className="badge text-success ">
                    Verified
                  </span>
                )}
              </div>

              </div>

             
              {/* RIGHT SIDE */}
              <div className="text-end">
                {kycStatus === 0 ? (
                  <span className="badge bg-warning text-dark px-3 py-2">
                    Pending
                  </span>
                ) : (
                  <span className="badge bg-success px-3 py-2">
                    Approved
                  </span>
                )}
              </div>

            </div>

          </div>
        </div>
      ))}

    </div>
  )}

</div>

      </div>

      {/* MODAL */}
      {showModal && (
        <DocumentModal
          show={showModal}
          onClose={() => {
            setShowModal(false);
            getUserData();
            getUserDocumentList();
          }}
        />
      )}
    </div>
  );
};

export default Kycdocument;
